export default function(address, address2, city, state, zipcode) {
    let slug = [address, address2, city, state, zipcode].filter(v => v).join('+').replace(/,/g, '').replace(/ /g, '+');
    return `https://www.google.com/maps/place/${slug}`
}
